import { computed, ref } from 'vue'

/** Полный номер — 12 цифр: 998 + 9 цифр. */
const PHONE_LENGTH = 12

/**
 * Поля формы с валидацией — перенос `useFormFields` из прошлого проекта.
 * Телефон хранится без кода страны, наружу отдаётся склеенным `998XXXXXXXXX`.
 */
export function useFormFields() {
  const requiredField = ref('')
  const isRequiredCorrect = computed(() => requiredField.value.trim().length > 0)

  const code = ref('+998')
  const phone = ref('')

  const phoneNumber = computed(() => code.value.substring(1) + phone.value.replace(/\D/g, ''))
  const isPhoneCorrect = computed(() => phoneNumber.value.length === PHONE_LENGTH)

  return { requiredField, isRequiredCorrect, code, phone, phoneNumber, isPhoneCorrect }
}
